<template>
    <div class="open_notification">
        <img src="/LogoIcon.svg" alt="logo" loading="lazy">
        <div class="notification_text">
            <b>Comixon</b>
            <p>{{ $t('notification.openApp') }}</p>
        </div>
        <a class="notification_button" href="https://apps.apple.com/us/app/comixon/id975815438?mt=8">{{
            $t('notification.open') }}</a>
    </div>
</template>

<script>
export default {
    name: "OpenAppStoreNotification",
};
</script>

<style>
.open_notification {
    z-index: 3;
    border-radius: 15px;
    background: #2F2F2F;
    color: white;
    padding: 12px 16px;
    font-size: 13px;
    font-weight: 600;
    position: fixed;
    bottom: 5px;
    left: 50%;
    transform: translateX(-50%);
    gap: 8px;
    max-width: 82vw;
    width: 380px;
    display: none;

    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

.notification_text {
    color: #ffffff;
}

.notification_text b {
    font-size: 15px;
}

.notification_text p {
    margin: 0;
    font-size: 13px;
}

.notification_button {
    background: #FFCC00;
    color: black;
    border: none;
    border-radius: 10px;
    cursor: pointer;
    font-weight: 700;
    font-size: 14px;
    padding: 4px 16px;
    text-decoration: none;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
}

.notification_button:hover {
    background-color: #ffa600;
}

@media (max-width: 1440px) {
    .open_notification {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 12px;
    }
}

@media (max-width: 460px) {
    .open_notification {
        max-width: 90vw;
    }
}

@media (max-width: 420px) {
    .notification_text p {
        font-size: 10px;
    }
}
</style>
